export async function generateBrandedCanvasFromImageUrl(imageUrl: string) {
  const watermark = "img/site-watermark.png";
  const { height, width } = await loadImageFromUrl(imageUrl);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  await drawImagesToCanvas(
    [
      { src: imageUrl, x: 0, y: 0 },
      {
        src: watermark,
        x: 20,
        y: 20,
      },
    ],
    canvas
  );

  return canvas;
}

export function downloadCanvasAsImage(canvas: HTMLCanvasElement, name: string) {
  // IE11
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const nav = window.navigator as any;
  if (nav.msSaveOrOpenBlob) {
    const file = `${name}.png`;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    const blob = (canvas as any).msToBlob();
    return nav.msSaveOrOpenBlob(blob, file);
  }

  const fileName = `${name}.jpg`;

  canvas.toBlob(
    (blob) => {
      if (!blob) {
        console.error("blob is empty");
      } else {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.setAttribute("download", fileName);
        a.dispatchEvent(new MouseEvent(`click`, { bubbles: true, cancelable: true, view: window }));
      }
    },
    "image/jpeg",
    0.95
  );
}

interface InputSource {
  src: string;
  x: number;
  y: number;
  dWidth?: number;
  dHeight?: number;
}

interface ImageParams extends InputSource {
  image: HTMLImageElement;
}

async function drawImagesToCanvas(
  inputSources: InputSource[] = [],
  canvas = document.createElement("canvas")
) {
  // Asynchronously load all remote images
  const imagePromises = inputSources.map((inputSource) => {
    return new Promise<ImageParams>((resolve, reject) => {
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = () => resolve({ ...inputSource, image });
      image.onerror = () => reject("error fetching image: " + image);
      image.src = inputSource.src;
    });
  });

  const ctx = canvas.getContext("2d");
  // Draw each image to the canvas in order, when loaded
  for (const imagePromise of imagePromises) {
    try {
      const { image, x, y, dWidth, dHeight } = await imagePromise;
      if (dWidth && dHeight) {
        ctx?.drawImage(image, x, y, dWidth, dHeight);
      } else {
        ctx?.drawImage(image, x, y);
      }
    } catch (error) {
      throw new Error("Error drawing image: " + imagePromise);
    }
  }
}

async function loadImageFromUrl(imageUrl: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();

    image.setAttribute("crossOrigin", "Anonymous");
    image.onload = () => resolve(image);
    image.onerror = () => reject("error fetching image: " + image);
    image.src = imageUrl;
  });
}
